import React from 'react';
import { sendPaidAmountForm } from './actions';
import Signature from '/react4xp/mixins/ui/button-signature';

type Props = {
    translations: Record<string, string>;
    firstStepResult: {
        paidAmountXML: string;
        taxpayerCode: string;
    };
};

export const PaidAmountSecondStepForm = (props: Props) => {
    const onSubmit = async (signedRequest: string) => {
        sendPaidAmountForm({
            signedRequest,
            taxpayerCode: props.firstStepResult.taxpayerCode,
        });
    };

    const onGetXml = async () => {
        return {
            data: props.firstStepResult.paidAmountXML,
        };
    };

    return (
        <Signature
            onGetXml={onGetXml}
            onSubmit={onSubmit}
            icon={true}
            translations={props.translations}
            signType="SIGN"
        >
            Подписать
        </Signature>
    );
};
